import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable @repo/internal/react/require-jsdoc */

/** @jsx jsx */
import { forwardRef } from 'react';
import { css, jsx } from '@emotion/react';
import { gridSize } from '@atlaskit/theme/constants';
var containerStyles = css({
  marginBottom: "".concat(gridSize() * 3, "px"),
  position: 'relative'
});
export var Container = function Container(props) {
  return (// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    jsx("div", _extends({
      css: containerStyles
    }, props))
  );
};
var spinnerBackdropStyles = css({
  display: 'flex',
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  alignItems: 'center',
  justifyContent: 'center',
  pointerEvents: 'none'
});
export var SpinnerBackdrop = function SpinnerBackdrop(_ref) {
  var children = _ref.children;
  return jsx("div", {
    css: spinnerBackdropStyles
  }, children);
};
var spinnerContainerStyles = css({
  position: 'relative',
  top: 0
});
export var SpinnerContainer = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children;
  return jsx("div", {
    css: spinnerContainerStyles,
    ref: ref
  }, children);
});